import styled from 'styled-components';
import { font, colors } from '@chegg-ui/theme';
import { Font } from '../common/styled/common';
var weight = font.weight,
  size = font.size;
export var GiftCodeContainer = styled.div.withConfig({
  componentId: "sc-nwmcj6-0"
})(["margin-left:10px;"]);
export var GiftCodeWrapper = styled.div.withConfig({
  componentId: "sc-nwmcj6-1"
})(["align-items:center;display:flex;flex-direction:row;"]);
export var BalanceWrapper = styled.div.withConfig({
  componentId: "sc-nwmcj6-2"
})(["padding-left:10px;"]);
export var BannerWrapper = styled.div.withConfig({
  componentId: "sc-nwmcj6-3"
})(["margin:10px 0;"]);
export var StyledValueText = styled.p.withConfig({
  componentId: "sc-nwmcj6-4"
})(["", ";font-weight:", ";font-size:", ";"], Font, weight.bold, size.px16);
export var StyledInfoText = styled.p.withConfig({
  componentId: "sc-nwmcj6-5"
})(["", ";font-weight:", ";font-size:", ";color:", ";padding-top:10px;max-width:350px;line-height:1.2;"], Font, weight.normal, size.px14, colors.grey);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/GiftCode/styled.js
// module id = 4578
// module chunks = 11